import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CompetitionIntensityArrayModel,
  CompetitionIntensityModel,
} from "../../models/CompetitionIntensityModel";

const initialCompetitionIntensityState: CompetitionIntensityArrayModel = {
  all_CompetitionIntensities: [],
  particular_CompetitionIntensity: {
    competitionIntensityId: 0,
    name: "",
    description: "",
    isActive: false,
  },
  isCompetitionIntensitiesFetching: false,
};
const CompetitionIntensitySlice = createSlice({
  name: "ProjectCompetitionIntensity",
  initialState: initialCompetitionIntensityState,
  reducers: {
    setCompetitionIntensities(
      state,
      action: PayloadAction<CompetitionIntensityModel[]>
    ) {
      state.all_CompetitionIntensities = action.payload;
    },
    setParticularCompetitionIntensity(
      state,
      action: PayloadAction<CompetitionIntensityModel>
    ) {
      state.particular_CompetitionIntensity = action.payload;
    },
    setIsCompetitionIntensitiesFetching(state, action: PayloadAction<boolean>) {
      state.isCompetitionIntensitiesFetching = action.payload;
    },
  },
});
export default CompetitionIntensitySlice;
